import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {API_URL} from '../constants';

export interface CommitteeDTO {
    id?: string;
    title: string;
    chapterId: string;
    userId: string;
}

@Injectable({
    providedIn: 'root',
})
export class CommitteeService {
    private apiUrl = `${API_URL}` + 'committees'; // Base API URL

    constructor(private http: HttpClient) {
    }


    /**
     * Get a committee by its ID.
     * @param id The ID of the committee.
     */
    getCommitteeById(id: string): Observable<CommitteeDTO> {
        return this.http.get<CommitteeDTO>(`${this.apiUrl}/${id}`);
    }

    /**
     * Create a new committee.
     * @param committee The committee data to create.
     */
    createCommittee(committee: CommitteeDTO): Observable<CommitteeDTO> {
        return this.http.post<CommitteeDTO>(this.apiUrl, committee);
    }

    /**
     * Update an existing committee by ID.
     * @param id The ID of the committee to update.
     * @param committee The updated committee data.
     */
    updateCommittee(id: string, committee: CommitteeDTO): Observable<CommitteeDTO> {
        return this.http.put<CommitteeDTO>(`${this.apiUrl}/${id}`, committee);
    }

    /**
     * Delete a committee by its ID.
     * @param id The ID of the committee to delete.
     */
    deleteCommittee(id: string): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}`);
    }

    /**
     * Get committees by chapter ID.
     * @param chapterId The ID of the chapter.
     */
    getCommitteesByChapterId(chapterId: string): Observable<CommitteeDTO[]> {
        return this.http.get<CommitteeDTO[]>(`${this.apiUrl}/chapter/${chapterId}`);
    }

    getAllBOTChairs(): Observable<CommitteeDTO[]> {
        return this.http.get<CommitteeDTO[]>(`${this.apiUrl}/getAllBOTChairs`);
    }


}
